// src/pages/Capabilities.jsx
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Reveal from '../components/Reveal';

import heroImg from '../assets/images/service1.png';

const CAPABILITIES = [
  {
    num: '01',
    title: 'Managed application support & maintenance',
    desc: 'We provide Level 2 and Level 3 application support covering bug fixes, performance optimization and release patch and upgrade activities. All incidents are handled through defined SLA based processes.',
    cards: [
      { icon: 'delivery', title: 'Delivery approach', desc: 'SLA based incident handling defined escalation paths and documented resolution processes.' },
      { icon: 'value',    title: 'Value',             desc: 'Operational continuity without full time hiring and reduced delivery risk.' },
    ],
  },
  {
    num: '02',
    title: 'Training & workforce development',
    desc: 'Our training programs are designed to build job-ready skills that support organizational staffing needs and individual career growth. Programs align with real delivery environments.',
    cards: [
      { icon: 'delivery', title: 'Delivery approach', desc: 'Cohort-based and individual learning tracks aligned to operational role requirements.' },
      { icon: 'value',    title: 'Value',             desc: 'Job-ready talent pipeline reducing onboarding time and training overhead.' },
    ],
  },
  {
    num: '03',
    title: 'Staffing & workforce delivery',
    desc: 'We operate as a workforce augmentation partner, providing trained professionals who work within client teams supported by internal delivery and quality processes.',
    cards: [
      { icon: 'delivery', title: 'Delivery approach', desc: 'Pre-vetted professionals integrated with client delivery workflows and oversight structures.' },
      { icon: 'value',    title: 'Value',             desc: 'Reduced hiring risk with maintained quality and performance accountability.' },
    ],
  },
  {
    num: '04',
    title: 'Cloud & infrastructure services',
    desc: 'We support cloud cost assessment, right-sizing and infrastructure optimization for organizations managing cloud workloads across government and enterprise environments.',
    cards: [
      { icon: 'delivery', title: 'Delivery approach', desc: 'Assessment-first methodology mapping workloads to cost, followed by optimization and monitoring.' },
      { icon: 'value',    title: 'Value',             desc: 'Sustainable cost control and improved infrastructure visibility without service disruption.' },
    ],
  },
];

function DeliveryIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#154DDE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>
    </svg>
  );
}

function ValueIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#154DDE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
    </svg>
  );
}

export default function Capabilities() {
  return (
    <>
      <SEO
        title="Capabilities — What We Deliver"
        description="Explore District Sourcing Tech's capabilities: managed IT services, training & workforce development, staffing solutions and cloud services for government and enterprise."
        url="https://districtsourcingtech.com/capabilities"
        keywords="IT capabilities, managed IT services, workforce development, staffing solutions, cloud services, government IT"
      />
      <Navbar variant="light" />

      <section className="career-hero">
        <div className="career-hero__bg">
          <img src={heroImg} alt="IT services team" />
        </div>
        <div className="career-hero__overlay" />
        <div className="career-hero__card">
          <p className="career-hero__label">Our services</p>
          <h1 className="title-1" style={{ marginBottom: '12px', marginTop: '4px' }}>What we deliver</h1>
          <p className="body-lg" style={{ color: 'var(--token-desc)', marginBottom: '32px' }}>
            Standardized IT services and workforce support designed for operational stability compliance and predictable delivery.
          </p>
          <Link to="/contact" className="btn btn-primary">Get started</Link>
        </div>
      </section>

      <section className="section">
        <div style={{ maxWidth: '1376px', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '0' }}>
          {CAPABILITIES.map((cap, i) => (
            <Reveal
              key={cap.num}
              className="cap-section"
              style={{ borderBottom: i < CAPABILITIES.length - 1 ? '1px solid var(--shades-400)' : 'none' }}
            >
              <div className="cap-section__num">
                <span className="cap-num-text">{cap.num}</span>
              </div>
              <div className="cap-section__content">
                <h2 className="title-4" style={{ marginBottom: '12px' }}>{cap.title}</h2>
                <p className="body-lg" style={{ color: 'var(--token-desc)', marginBottom: '32px', maxWidth: '680px' }}>{cap.desc}</p>
                <div className="cap-cards">
                  {cap.cards.map((card, j) => (
                    <Reveal key={card.title} delay={j * 100} className="cap-card">
                      <div className="cap-card__icon">
                        {card.icon === 'delivery' ? <DeliveryIcon /> : <ValueIcon />}
                      </div>
                      <h3 className="title-6" style={{ marginBottom: '8px' }}>{card.title}</h3>
                      <p className="body-sm" style={{ color: 'var(--token-desc)' }}>{card.desc}</p>
                    </Reveal>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <Footer />
    </>
  );
}
